import { Controller } from "@hotwired/stimulus"

// Contrôleur Stimulus pour gérer les interactions avec le fil d'ariane
// Usage: data-controller="breadcrumbs"
export default class extends Controller {
  static targets = ["link"]

  connect() {
    // Initialisation si nécessaire
    this.trackNavigation()
  }

  // Track les clics sur les breadcrumbs (pour analytics)
  trackNavigation() {
    this.linkTargets.forEach((link, index) => {
      link.addEventListener("click", () => {
        this.sendAnalytics("breadcrumb_click", {
          position: index + 1,
          label: link.textContent.trim(),
          url: link.href
        })
      })
    })
  }

  sendAnalytics(eventName, data) {
    // Matomo Tag Manager
    if (window._mtm) {
      window._mtm.push({
        event: eventName,
        ...data
      })
    }

    // Google Analytics 4
    if (window.gtag) {
      window.gtag('event', eventName, data)
    }

  }
}
